import { cn } from '@avanta/shared/utils/cn';
import {
  dropdownContentBase,
  dropdownFormWrapper,
  dropdownSelectItem,
  dropdownTriggerBase,
  dropdownTriggerInvalid,
} from '../styles/dropdown';

export const selectWrapper = cn(dropdownFormWrapper, 'min-w-0 notranslate');

export const selectTrigger = cn(
  dropdownTriggerBase,
  'relative grid w-full min-w-0 grid-cols-[minmax(0,1fr)_auto] px-4 py-2 text-left',
  'data-has-left-icon:pl-10',
  'data-[placeholder]:text-gray-400',
  dropdownTriggerInvalid
);

export const selectReadOnlyTrigger = 'cursor-default border-white bg-mint-100 text-denim-800';

export const selectContent = cn(
  dropdownContentBase,
  'w-(--radix-select-trigger-width) max-w-(--radix-select-trigger-width)',
  'origin-[--radix-select-content-transform-origin]',
  // slide in by side
  'data-[side=top]:slide-in-from-bottom-2 data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2',
  // offset by side
  'data-[side=top]:-translate-y-1 data-[side=bottom]:translate-y-1',
  'data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1'
);

export const selectViewport = 'w-full min-w-0 p-1 scroll-my-1';

export const selectItem = cn(dropdownSelectItem, 'h-auto min-h-10 min-w-0 overflow-hidden');

export const selectScrollButton = 'flex cursor-default items-center justify-center py-1';
